/// <amd-module name="VSS/Platform/Util/Cookie" />

/**
 * getCookie returns the value for the specified cookie. If there is no value for the cookie
 * an empty string will be returned for the value.
 *
 * @param name Name of the cookie
 * @returns Value for the cookie if it is set, otherwise empty string.
 */
export function getCookie(name: string): string {
    // Ensure we have access to the cookies and a cookie name was supplied.
    if (document.cookie && document.cookie.length > 0 && name) {
        const cookieStart = name + "=";
        const cookies = document.cookie.split(";");

        // Go through each cookie and find the one that starts with <name>=
        for (let index = 0; index < cookies.length; index++) {
            // Trim leading whitespace for the cookie
            let cookie = cookies[index];
            while (cookie.charAt(0) == " ") {
                cookie = cookie.substring(1);
            }

            // If cookie.startsWith the computed cookie name we will return the value portion.
            if (cookie.indexOf(cookieStart) == 0) {
                return decodeURIComponent(cookie.substring(cookieStart.length));
            }
        }
    }

    return "";
}

/**
 * Sets a cookie with the specified options
 *
 * @param name Name of cookie
 * @param value Value of cookie
 * @param path Path for which to set cookie, defaults to '/'
 * @param expires Optional, data in GMTString format, indicating the time of expiration
 * @param maxAge Optional, maximum age of the cookie in seconds
 */
export function setCookie(name: string, value: string, path: string = "/", expires?: string, maxAge?: number) {
    const attributes: string[] = [`${name}=${value}`, `path=${path}`];

    if (expires) {
        attributes.push(`expires=${expires}`);
    }

    if (maxAge) {
        attributes.push(`max-age=${maxAge}`);
    }

    // Set secure flag if current connection is https
    if (window.location.protocol.indexOf("https") !== -1) {
        attributes.push("secure");
    }

    document.cookie = attributes.join(";");
}

/**
 * Deletes the cookie with the specified name
 *
 * @param name Name of the cookie to delete
 * @param path Path for which to delete the cookie, defaults to '/'
 */
export function deleteCookie(name: string, path: string = "/") {
    setCookie(name, "", path, "Thu, 01 Jan 1970 00:00:01 GMT");
}
